var React = require('react');

function Private (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6 0C2.691 0 0 2.692 0 6s2.691 6 6 6 6-2.692 6-6-2.692-6-6-6zm4.412 8.617c-.718-.718-2.583-1.314-2.583-1.314-.502.519-1.132.861-1.829.861s-1.328-.343-1.829-.861c0 0-1.865.596-2.583 1.313a.565.565 0 00-.086.125A5.226 5.226 0 01.725 6C.725 3.091 3.091.725 6 .725S11.275 3.091 11.275 6a5.228 5.228 0 01-.777 2.741.592.592 0 00-.086-.124zM6 2.106c-1.305 0-2.363 1.11-2.363 2.48S4.695 7.62 6 7.62s2.363-1.664 2.363-3.034S7.305 2.106 6 2.106z"}));
}

Private.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12"};

module.exports = Private;

Private.default = Private;
